import React from 'react';
import EmptyState from '../../EmptyState';

// A free day. Phrased as good news, because for a teacher it usually is.

const CalendarIcon = (
  <svg
    width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
  >
    <rect x="3" y="5" width="18" height="16" rx="2.5" />
    <path d="M3 9h18M8 3v4M16 3v4" />
  </svg>
);

// `reading` is the day's, from DayView (#626, #629).
export default function DayEmpty({ reading, weekdayName, onAddLesson }) {
  return (
    <EmptyState
      reading={reading}
      illustration={CalendarIcon}
      title={`A free ${weekdayName}.`}
      description="No lessons scheduled. Take it. Or add a one-off lesson if a parent texts."
      actionLabel="+ Add a lesson"
      onAction={onAddLesson}
    />
  );
}
